import React from "react";
import { View, StyleSheet, TouchableOpacity, Platform, Dimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import ImageCarousel from "../ImageCarousel/ImageCarousel";
import { COLORS, STRINGS } from "../../constants";
import { FontAwesomeIcon as NativeFontawesome } from "@fortawesome/react-native-fontawesome";
import { FontAwesomeIcon as WebFontawesome } from "@fortawesome/react-fontawesome";

const FontAwesomeIcon = Platform.OS === "web" ? WebFontawesome : NativeFontawesome;

const closeBtnSize = Platform.OS === "web" ? "2xl" : 32;
const screenHeight = Dimensions.get("window").height;
const height = Platform.OS === "web" ? screenHeight * 0.75 : screenHeight;

/**
 * ImageGalleryModal component displays a modal with an image carousel and a close button.
 *
 * @component
 * @param {object} props - Component props.
 * @param {object} props.navigation - React Navigation object for navigating between screens.
 * @param {object} props.route - Route object containing parameters passed to the screen.
 * @param {object} props.route.params - Parameters passed to the route.
 * @param {Array} props.route.params.data - Array of image data to display in the carousel.
 *
 * @example
 * <ImageGalleryModal navigation={navigation} route={{ params: { data: images } }} />
 */
const ImageGalleryModal = ({ navigation, route }) => {
  const { data, accessibilityLabel } = route.params;
  const insets = useSafeAreaInsets();

  return (
    <View style={[styles.modalContainer, Platform.OS === "android" ? { paddingTop: insets.top } : null]}>
      <TouchableOpacity
        testID="close-button"
        accessibilityValue={{ text: STRINGS.closeImageButton }}
        accessibilityLabel={STRINGS.closeImageButton}
        onPress={() => navigation.goBack()}
        style={styles.closeButton}
      >
        <FontAwesomeIcon icon={faCircleXmark} size={closeBtnSize} color={COLORS.border} />
      </TouchableOpacity>

      <ImageCarousel data={data} height={height} accessibilityLabel={accessibilityLabel} />
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: COLORS.textLight,
  },
  closeButton: {
    alignSelf: "flex-end",
    padding: 16,
    paddingRight: 10,
  },
});

export default ImageGalleryModal;
